<template>
  <IconLucideSearch />
</template>
